import { createStorage } from '@aviata/storage';

import { PASSENGERS_SESSION_STORAGE_KEY } from '../config';
import { localPassengersStorage } from './local-passengers-storage';

const sessionStorageWrapper = createStorage(sessionStorage);

/**
 * Drop every session-scoped passenger-entry blob: the per-slot booking draft
 * (which the flow pre-fills on re-entry) and the locally-added passengers list.
 *
 * Wired to the app-exit lifecycle so a later visit never restores passenger
 * data that went stale while the user was away — e.g. a DOB edited in the
 * cabinet that would otherwise land a pre-filled passenger in the wrong age
 * tier, or a citizenship change that no longer matches the saved document.
 *
 * Account-saved passengers are intentionally left alone: they live on the
 * backend and are re-fetched as the source of truth on the next entry.
 */
export const clearPersistedPassengers = () => {
  sessionStorageWrapper.remove(PASSENGERS_SESSION_STORAGE_KEY);
  localPassengersStorage.clear();
};
